<template>
    <v-dialog v-if="kugel" v-model="dialog" persistent>
        <v-card class="pa-5">
            <div class="primary--text title mb-3">
                <span v-if="!kugel.id">Neue Kugel für {{kugel.ownerName}}</span>
                <span v-else>Kugel ändern für {{kugel.ownerName}}</span>
            </div>
            <div class="closeBtn">
                <v-btn icon @click="cancel"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-text-field v-model="kugel.nr" label="Kugelnummer" clearable></v-text-field>
            <v-text-field v-model="kugel.kommentar" label="Kommentar (optional)" clearable></v-text-field>
            <v-text-field v-model="kugel.gueltigBis" label="Gültig bis (optional)" clearable type="date"></v-text-field>
            <v-alert color="error" v-model="kugelNrMissing" text icon="mdi-alert" >
                Bitte eine Kugelnummer eingeben!
            </v-alert>
            <v-row no-gutters>
                <v-col>
                    <v-btn @click="cancel()">
                        <v-icon class="mr-1">mdi-close</v-icon>Abbrechen
                    </v-btn>
                </v-col>
                <v-col class="text-right">
                    <v-btn @click="save()" color="primary">
                        <v-icon class="mr-1">mdi-check</v-icon>Speichern
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "kugel-edit",
    props: ['kugel'],
    computed: {
        editKugel(){ return this.$route.query.editKugel}
    },
    data: () => ({
        kugelNrMissing: false,
        dialog: false
    }),
    methods: {
        async save(){
            if ( !this.kugel.nr ) {
                this.kugelNrMissing = true
                return
            }
            const reply = await this.kugel.save()
            if ( reply.successful ) {
                this.$emit('saved', reply.content);
                this.cancel()
            }
        },
        cancel(){
            window.history.back()
        }
    },
    watch: {
        'kugel.nr'(to, from){
            this.kugelNrMissing = (to === '' || to === undefined || to === null) && from !== undefined
        },
        editKugel(to, from){
            this.dialog = to && !from
        }
    }
}
</script>

<style scoped>
    .closeBtn{position: absolute; top: 12px; right: 12px}
</style>